import { em, getBreakpointValue, useMantineTheme } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";

export const MOBILE_NAVBAR_BREAKPOINT = "sm";

// Same query AppShell uses to switch the navbar to its full-width mobile drawer.
export function useIsMobileNavbar() {
  const theme = useMantineTheme();
  return useMediaQuery(
    `(max-width: ${em(getBreakpointValue(MOBILE_NAVBAR_BREAKPOINT, theme.breakpoints) - 0.1)})`,
    undefined,
    { getInitialValueInEffect: false },
  );
}
